import { IconUpload } from '@bbl-digital/snorre-v2'

type Props = {} & React.ComponentProps<'label'>

const ArchiveFilePickerButton = (props: Props) => {
  return (
    <>
      <label
        {...props}
        className="flex min-w-7 cursor-pointer flex-col items-center justify-center gap-[12px] font-semibold text-text-brand mt-2 text-center"
        tabIndex={0}
        role="button"
      >
        <IconUpload className="rounded-md border border-border-light p-[12px] text-surface-common-icon-color" />
        Legg til fra styrets arkiv
      </label>
    </>
  )
}

export default ArchiveFilePickerButton
